// extracted by mini-css-extract-plugin
export var active = "_bw-2";
export var highlight = "_bw-1";
export var highlightLayer = "_bw-0";
export var issuePopover = "_bw-3";
export var statusIcon = "_bw-4";